exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-media__icon {\n  height: 100%;\n  opacity: 0.8;\n  cursor: pointer;\n}\n.social-media__icon:hover {\n  opacity: 1;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ec4fedc","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/FooterComponent.vue
// module id = 334
// module chunks = 4